import { useState } from 'react';
import { Icon, TableRowSpanningBoxProps } from '@hevoio/hevo-ui-toolkit';
import { VPCPeeringConnection } from '../interface';
import type { ConnectivityTableContext } from './ConnectivityTable';
import styles from './ConnectivityColumns.module.scss';

const PENDING_ACCEPTANCE = 'PENDING_ACCEPTANCE';
const REQUEST_SUBMITTED = 'REQUEST_SUBMITTED';

function RequestSubmittedBanner() {
  const [showWhy, setShowWhy] = useState(false);

  return (
    <div className={styles.acceptanceBanner} data-id='request-submitted-banner'>
      <Icon name='info' size={1} className={`text-sub-600 ${styles.bannerIcon}`} />
      <div>
        <span>
          Request is under review by our infrastructure team.{' '}
          <button
            type='button'
            className={styles.howToAcceptLink}
            data-id='request-submitted-why-link'
            onClick={() => setShowWhy(value => !value)}
          >
            Why does this happen?
          </button>
        </span>
        {showWhy && (
          <p className={styles.whyExplanation} data-id='request-submitted-why-text'>
            Most VPC peering requests are provisioned automatically within a few minutes. However,
            some requests require manual setup by the Hevo infrastructure team due to network or
            infrastructure requirements. No action is required from your end. The status will
            update automatically once the peering connection is ready.
          </p>
        )}
      </div>
    </div>
  );
}

export function ConnectivityBanner({
  row,
  globalContext
}: TableRowSpanningBoxProps<VPCPeeringConnection, ConnectivityTableContext>) {
  const status = row.data.status?.value;

  if (status === REQUEST_SUBMITTED) {
    return <RequestSubmittedBanner />;
  }

  if (status !== PENDING_ACCEPTANCE) {
    return null;
  }

  return (
    <div className={styles.acceptanceBanner}>
      <Icon name='info' size={1} className={`text-sub-600 ${styles.bannerIcon}`} />
      <span>
        Hevo sent a peering connection request to your AWS account. Accept it in the AWS console to
        finish setup.{' '}
        <button
          type='button'
          className={styles.howToAcceptLink}
          data-id='how-to-accept-link'
          onClick={() => globalContext?.onHowToAccept(row.data)}
        >
          How to accept
        </button>
      </span>
    </div>
  );
}
